import script from "./LiveSessionResultsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LiveSessionResultsView.vue?vue&type=script&setup=true&lang=ts"

import "./LiveSessionResultsView.vue?vue&type=style&index=0&id=252b152e&lang=css"

const __exports__ = script;

export default __exports__